export class GameAssets {
    public static loading: any;
    public static textures: any;
    public static skeletons: any;
    public static audio: any;
}
